/**
 * Approved by product owner 2026-08-24. Display-only: rewrites Guide's
 * "Checkout+" button in the cart drawer to carry the order total with
 * protection — "Checkout+ | $143.96 USD" over "Your Shipping is Protected"
 * (modeled on Seel's native checkout button, which Guide lacks).
 *
 * The protection fee is read from Guide's own widget text ("Protected
 * Checkout $1.96"); when the Guide line item is already in the cart the fee
 * is not added twice. This script never mutates the cart — it only rewrites
 * the button's label. If Guide renames its classes or stops rendering the
 * widget, every selector here misses and the button keeps Guide's stock
 * label; nothing breaks.
 */
(function () {
  if (window.__guideCheckoutLabel) return;
  window.__guideCheckoutLabel = true;

  var GUIDE_VENDOR = 'Guide';
  var scheduled = false;

  function feeCents() {
    var widget = document.querySelector('.cart-drawer__dialog .widget-main');
    if (!widget) return 0;
    var match = widget.textContent.match(/\$\s?([\d,]+(?:\.\d{1,2})?)/);
    if (!match) return 0;
    return Math.round(parseFloat(match[1].replace(/,/g, '')) * 100);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2) + ' USD';
  }

  // Guide mounts its info popup on <body> (lazily, on first click) with a huge
  // z-index — but the drawer is a modal <dialog> in the browser's top layer,
  // which paints above ALL body-level content regardless of z-index. Nesting
  // the popup inside the drawer doesn't work either: the drawer's transform
  // makes it the containing block, squeezing the full-viewport overlay into
  // the drawer column. Fix: host the popup in its own <dialog> and showModal()
  // it while Guide has it open — a top-layer element opened after the drawer
  // stacks above the drawer, at true viewport size.
  var popupHost = null;
  var portalObserver = null;

  function ensurePopupHost() {
    if (popupHost) return popupHost;
    popupHost = document.createElement('dialog');
    popupHost.id = 'guide-popup-host';
    popupHost.style.cssText = 'padding:0;border:0;background:transparent;width:100vw;height:100vh;max-width:100vw;max-height:100vh;inset:0;overflow:visible;';
    var style = document.createElement('style');
    style.textContent = '#guide-popup-host::backdrop{background:transparent}'; // Guide draws its own dim overlay
    document.head.appendChild(style);
    document.body.appendChild(popupHost);
    // Guide may remove the portal straight out of the host on close
    new MutationObserver(function () {
      if (popupHost.open && !popupHost.querySelector('.gwp-ipopup__portal-root')) popupHost.close();
    }).observe(popupHost, { childList: true });
    // ESC / programmatic close of the host must also close Guide's popup state
    popupHost.addEventListener('close', function () {
      var portal = document.querySelector('.gwp-ipopup__portal-root');
      if (!portal || !guideOverlayVisible(portal)) return;
      var btn = portal.querySelector('[class*="close" i]') || portal.querySelector('button');
      if (btn) btn.click();
    });
    return popupHost;
  }

  function guideOverlayVisible(portal) {
    var overlay = portal.querySelector('.gwp-ipopup__overlay');
    return !!overlay && getComputedStyle(overlay).display !== 'none' && overlay.getClientRects().length > 0;
  }

  var observedPortal = null;

  function syncPopupHost() {
    var portal = document.querySelector('.gwp-ipopup__portal-root');
    if (!portal) {
      // Guide removes the portal from the DOM on close — the host must not
      // linger open (it would invisibly block clicks on the drawer beneath).
      if (popupHost && popupHost.open) popupHost.close();
      return;
    }
    if (portal !== observedPortal) {
      if (portalObserver) portalObserver.disconnect();
      portalObserver = new MutationObserver(syncPopupHost);
      portalObserver.observe(portal, { childList: true, subtree: true, attributes: true });
      observedPortal = portal;
    }
    var host = ensurePopupHost();
    // The portal lives on <body> by default (so Guide's visibility state stays
    // measurable) and only moves into the host at the moment it opens — a
    // closed <dialog> renders display:none, which would hide it forever.
    var visible = guideOverlayVisible(portal);
    if (visible) {
      if (portal.parentElement !== host) host.appendChild(portal);
      if (!host.open) {
        try { host.showModal(); } catch (e) { /* already open or detached — harmless */ }
      }
    } else {
      if (host.open) host.close();
      if (portal.parentElement === host) document.body.appendChild(portal);
    }
  }

  // The portal mounts lazily on the first info-icon click — watch for it.
  var bodyObserver = new MutationObserver(function () {
    if (document.querySelector('.gwp-ipopup__portal-root')) syncPopupHost();
  });
  bodyObserver.observe(document.body, { childList: true });

  function apply(cart) {
    syncPopupHost();
    var title = document.querySelector('.cart-drawer__dialog .guide-protection-title');
    if (title && title.textContent !== 'Shipping Protection') title.textContent = 'Shipping Protection';

    // Move Guide's protection row out of the checkout-button stack so it sits
    // between the Subtotal row and the tax note. insertBefore MOVES the node —
    // Guide's own listeners and its #guide-protection-price updates survive.
    var widget = document.querySelector('.cart-drawer__dialog .widget-main');
    var totalContainer = document.querySelector('.cart-drawer__dialog .cart__total-container');
    var taxNote = totalContainer && totalContainer.querySelector('.tax-note');
    if (widget && taxNote && widget.parentElement !== totalContainer) {
      totalContainer.insertBefore(widget, taxNote);
    }
    var btn = document.querySelector('.cart-drawer__dialog .guide-v2-protected-button');
    if (!btn) return;
    var total = cart.total_price;
    var hasGuideLine = (cart.items || []).some(function (item) { return item.vendor === GUIDE_VENDOR; });
    if (!hasGuideLine) total += feeCents();
    var label = 'Checkout+ | ' + money(total);
    if (btn.dataset.guideLabel === label) return; // already current — keeps the observer loop-free
    btn.dataset.guideLabel = label;
    btn.textContent = '';
    var line1 = document.createElement('span');
    line1.textContent = label;
    line1.style.display = 'block';
    var line2 = document.createElement('span');
    line2.textContent = 'With Shipping Protection';
    line2.style.cssText = 'display:block;font-size:0.75em;font-weight:400;opacity:0.9;';
    btn.appendChild(line1);
    btn.appendChild(line2);
  }

  function refresh() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      fetch('/cart.js')
        .then(function (res) { return res.json(); })
        .then(apply)
        .catch(function () {}); // display-only; a failed fetch must never surface errors
    }, 150);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      // our own label rewrite mutates the button subtree — ignore it
      if (target.nodeType === 1 && target.closest && target.closest('.guide-v2-protected-button')) continue;
      refresh();
      return;
    }
  });

  function arm() {
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (!dialog) return false;
    // attributeFilter: open/close of the dialog re-runs refresh -> placeInfoPopup
    observer.observe(dialog, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    refresh();
    return true;
  }

  document.addEventListener('cart:update', refresh);
  if (!arm()) document.addEventListener('DOMContentLoaded', arm);
})();
